import { VListItem } from '../VListItem';
import { usePickListContext } from './hook';

type VGroupListProp = {
  groupListTitle?: string;
};

const VGroupList = ({ groupListTitle }: VGroupListProp) => {
  const { groupList, selectedGroup, selectGroup, allItemsGroup } =
    usePickListContext();

  return (
    <VListItem
      list={[allItemsGroup, ...groupList]}
      value={selectedGroup}
      onChange={selectGroup}
      title={groupListTitle}
    />
  );
};

export default VGroupList;
